import styled from "styled-components";

import { css } from "styled-components";
const fontImports = css`
  @import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap");
`;

export const ModalWrapper = styled.div`
  ${fontImports}

  position: fixed;
  inset: 0;
  z-index: 1000;

  .overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
  }

  .modalContent {
    position: relative;
    margin: auto;
    top: 10%;
    background: ${({ theme }) => theme.background};
    border-radius: 20px;
    max-width: 420px;
    width: 90%;
    overflow: hidden;
    z-index: 1001;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  }
  .stickyCardPrimatio {
    background-color: #dddf22;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    z-index: 10;
  }

  .containerTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
  }

  .qrcodeTitle {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    flex: 1;
  }

  .closeIcon {
    font-size: 24px;
    cursor: pointer;
  }

  .stickyCard {
    background-color: ${({ theme }) => theme.background};
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    padding: 20px;
    z-index: 5;
    transition: background-color 0.3s ease-in;
  }

  .badgeContainer {
    width: 140px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .storeBadge {
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }

  .storeWrapper {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: wrap;
  }

  .storeRow {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .storeTextWrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .storeSub {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.text};
    margin-bottom: 4px;
  }

  .storeNameApple {
    font-family: "Roboto", "Montserrat", "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI",
      Roboto, "Helvetica Neue", Arial, sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: ${({ theme }) => theme.text};
  }

  .storeNameGoogle {
    font-family: "Roboto", "Montserrat", "Google Sans", Roboto, "Helvetica Neue", Arial, sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: ${({ theme }) => theme.text};
  }

  .storeBox {
    flex: 1;
    min-width: 140px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .storeColumn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .storeImage {
    height: 20px;
    object-fit: contain;
  }

  .storeIcon {
    flex-shrink: 0;
  }

  .qrcodePlaceholder {
    width: 100px;
    height: 100px;
    background-color: #eee;
    border-radius: 10px;
  }
`;
